export const data: any[] = [
  {
    title: 'Maestros',
    key: 'mastersModule',
    icon: 'icmn icmn-user',
    children: [
      {
        title: 'Colaboradores',
        key: 'mastersCollaboratorsView',
        url: '/masters/collaborators',
      },
      {
        title: 'Tipo de Planilla',
        key: 'mastersPayrollTypeView',
        url: '/masters/payroll-type',
      },
    ],
  },
  // {
  //   title: 'Area TI',
  //   key: 'areatiModule',
  //   url: '/area-ti',
  //   icon: 'icmn icmn-home',
  // },
  {
    title: 'Desempeño L.',
    key: 'performanceModule',
    icon: 'icmn icmn-stats-dots',
    children: [
      {
        title: 'Grado/Banda',
        key: 'performanceBandGradeView',
        url: '/performance/band-grade',
      },
      {
        title: 'Incremento',
        key: 'performanceIncreaseView',
        url: '/performance/increase',
      },
      {
        title: 'Operarios',
        key: 'performanceOperatorsView',
        url: '/performance/operators',
      },
    ],
  },
  {
    title: 'Simulación',
    key: 'simulationModule',
    icon: 'icmn icmn-newspaper',
    children: [
      {
        title: 'Crear simulación',
        key: 'simulationCreateView',
        url: '/simulation/create',
      },
      {
        title: 'Historial',
        key: 'simulationHistoryView',
        url: '/simulation/history',
      },
      {
        title: 'Aprobados',
        key: 'simulationApprovedView',
        url: '/simulation/approved',
      },
    ],
  },
]
